export default ({ Factory, Presets }) => ({

  /**
   * Загрузка файла на сервер
   * @param {Object} file - файл
   */
  upload: (file) => {
    let formData = new FormData()
    formData.append('file', file)
    return Factory.post(formData, Presets.headers.MULTIPART)
  },

  /**
   * Удаление файла с сервера
   * @param {String} name - имя файла
   */
  remove: (name) => Factory[name].delete()
})